export const snakeToCamel = (str: string) => {
  return str
    .toLowerCase()
    .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const camelToSnake = (str: string) => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

export const snakeToPascal = (str: string): string => {
  return str
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
};

/**
 * Converts a given object from case to another case.
 * This case conversion is done recursively and uses a provided
 * function to convert the keys to the case of choice.
 *
 * @param obj - The object to convert.
 * @param caseFn - The function to use to convert the object.
 * @returns The converted object.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertObjectToCase = <T extends Record<string, any>>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: Record<string, any>,
  caseFn: (str: string) => string
): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item =>
      convertObjectToCase<T>(item, caseFn)
    ) as unknown as T;
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      caseFn(key),
      convertObjectToCase<T>(value, caseFn),
    ])
  ) as T;
};
